import { setTitle } from '@/utils/common-js'
import { useEffect, useRef } from 'react'
import { useAdChannelStore } from '@/store/adChannelCode.store'
import getHostNameObj from '@/hooks/get-host-name-obj'

export const useTitleAndFavicon = () => {
  const { channelValue, noStandardChannel, adChannelCode } = useAdChannelStore(state => state)
  const hostNameObj = getHostNameObj()
  const prevChannelValue = useRef<string[] | null>([])

  // 修改Favicon图标
  const changeIcoFavicons = (url: string) => {
    const favicons = document.querySelectorAll('link[rel="icon"], link[rel="shortcut icon"], link[rel="apple-touch-icon"]')
    favicons.length > 0 && favicons.forEach(link => link.parentNode!.removeChild(link))

    const favicon = document.createElement('link')
    favicon.rel = 'icon'
    favicon.type = 'image/x-icon'
    favicon.href = new URL(url, window.location.origin).toString()
    document.head.appendChild(favicon)

    const appleIcon = document.createElement('link')
    appleIcon.rel = 'apple-touch-icon'
    appleIcon.type = 'image/x-icon'
    appleIcon.href = new URL(url, window.location.origin).toString()
    document.head.appendChild(appleIcon)
  }

  useEffect(() => {
    if (prevChannelValue.current !== channelValue || noStandardChannel) {
      prevChannelValue.current = channelValue
        switch (true) {
          case channelValue.includes('jiSuJieKuan'):
            setTitle('极速借款')
            return
          case channelValue.includes('daidaijia'):
            setTitle('贷贷嘉')
            changeIcoFavicons('daidaijia.ico')
            return
          case channelValue.includes('daidaijiaRed'):
            setTitle('贷贷嘉')
            changeIcoFavicons('daidaijia-red.ico')
            return
          case channelValue.includes('crmDisseminate'):
            setTitle('crm系统')
            changeIcoFavicons('crm-favicon.ico')
            return
          case noStandardChannel:
            if (['cemAcm', 'WFTM52'].includes(adChannelCode)) { // 特殊处理
              setTitle('有钱钱包')
            } else {
              setTitle('有钱来')
            }
            changeIcoFavicons('logo-blue.ico')
            return
          case channelValue.includes('financeBlueTheme'):
            changeIcoFavicons('logo-blue.ico')
            return
          case channelValue.includes('shenfutong'):
            setTitle('神付通')
            changeIcoFavicons('shenfutong-red.ico')
            return
          case channelValue.includes('daixiaoyouTF'):
            setTitle('贷小悠')
            changeIcoFavicons('daixiaoyou-tf-logo.ico')
            return
          case channelValue.includes('daixiaoyou'):
            setTitle('贷小悠')
            changeIcoFavicons('daixiaoyou-red.ico')
            return
          default:
            setTitle(hostNameObj.appName)
            changeIcoFavicons(hostNameObj.favicon)
        }
    }
  }, [channelValue, hostNameObj.favicon, hostNameObj.appName, noStandardChannel])
}
